import { FC, SVGProps } from 'react';

export const MessageIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			d='M67.125 12.5C67.8875 12.5 68.6188 12.8107 69.1579 13.3637C69.6971 13.9167 70 14.6667 70 15.4487V56.7308C70 57.5128 69.6971 58.2628 69.1579 58.8158C68.6188 59.3688 67.8875 59.6795 67.125 59.6795H26.19C25.6193 59.6795 25.0658 59.8747 24.6214 60.2328L16.5686 66.7216C14.9331 68.0395 12.5 66.8753 12.5 64.7749V15.4487C12.5 14.6667 12.8029 13.9167 13.3421 13.3637C13.8812 12.8107 14.6125 12.5 15.375 12.5H67.125ZM64.25 20.8974C64.25 19.5167 63.1307 18.3974 61.75 18.3974H20.75C19.3693 18.3974 18.25 19.5167 18.25 20.8974V52.6412C18.25 54.7415 20.683 55.9056 22.3185 54.5879L22.6319 54.3353C23.0763 53.9773 23.6298 53.7821 24.2005 53.7821H61.75C63.1307 53.7821 64.25 52.6628 64.25 51.2821V20.8974Z'
			fill='currentColor'
		/>
	</svg>
);
